import { useTranslation } from '@gem/modules/i18n';

interface IDeepLinkErrorPresenter {
  title: string;
  subtitle: string;
}

interface IDeepLinkErrorPresenterParams {
  isExpired?: boolean;
}

export function useDeepLinkErrorPresenter(
  params: IDeepLinkErrorPresenterParams
): IDeepLinkErrorPresenter {
  const { t } = useTranslation();

  const presenter = {
    get title(): string {
      if (params.isExpired) {
        return t('deeplink_title_expired');
      }
      return t('deeplink_title_invalid');
    },

    get subtitle(): string {
      if (params.isExpired) {
        return t('deeplink_subtitle_expired');
      }
      return t('deeplink_subtitle_invalid');
    },
  };
  return presenter;
}
